var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"masterDetail"},[_c('MasterList',{attrs:{"items":_vm.functions,"route":"Function"}}),(_vm.$route.params.name)?_c('TabControl',{staticClass:"detail",attrs:{"tabs":_vm.tabs}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }